var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame inline",class:{active: _vm.active, TA: _vm.isTestAchat, left:_vm.left},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"check-button margin-right",class:{TA:_vm.isTestAchat}}),_vm._v(" "),_c('h4',{staticClass:"weight-normal"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ac00253","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/CheckButton.vue
// module id = null
// module chunks = 